var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pessoa-aba',[_c('div',{staticClass:"wrapper m-t-n m-b"},[_vm._v(" App indisponível no momento. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }